<!-- 审批模板 -->
<template>
<basic-container>
  <div class="width-p100 bb-sm-primary mb-xxs pb-xs ds-fx flex-direction-row justify-content-start align-items-center">
    <i class="el-icon-document color-primary mr-sm"></i>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{path:$route.query.path,query:{runId:$route.query.runId,name:$route.query.parentName}}">{{$route.query.parentName}}</el-breadcrumb-item>
      <el-breadcrumb-item>审批流程</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="title">
    <i class="el-icon-s-unfold blue"></i><span v-text="configData.OBJ_TITLE?configData.OBJ_TITLE.ITEM_VALUE:''"></span>
  </div>
  <el-main>
    <template v-for="(item,index) in configData.col">
      <el-col :span="4" :key="index" class="left">
        <span v-text="item.ITEM_TITLE"></span>
      </el-col>
      <el-col :span="8" :key="index">
        <span v-text="item.ITEM_VALUE||''"></span>
      </el-col>
    </template>
  </el-main>
  <div class="title">
    <i class="el-icon-s-unfold blue"></i>审批录入
  </div>
  <el-main>
    <el-form v-if="configData.SPRID" v-loading="loading" :model="form" :disabled="formDisabled" size="mini" ref="approvalForm" label-position="right" class="form" label-width="200px">
      <el-form-item v-if="form.FLOWID!=-1" :label="configData.FLOWID.ITEM_TITLE" prop="FLOWID"
       :rules='form.FLOWID!=-1?[{required:true,message:`请选择${configData.FLOWID.ITEM_TITLE.substring(0,configData.FLOWID.ITEM_TITLE.length-1)}`,trigger:""}]:[]'>
        <el-select v-model="form.FLOWID" :placeholder="`请选择${configData.FLOWID.ITEM_TITLE.substring(0,configData.FLOWID.ITEM_TITLE.length-1)}`" class="selectWidth"
         @change="FLOWIDChange">
          <el-option v-for="(item,index) in flowList" :key="index" :label="item.FLOWID" :value="item.FLOWID"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.FLOWID!=-1" label="">
        <div class="flowDetail">
          <span v-for="(item,index) in flowDetail" :key="index" v-text="item.result"></span>
        </div>
      </el-form-item>
      <el-form-item :label="configData.SPRID.ITEM_TITLE" prop="SPRID"
       :rules='[{required:true,message:`请选择${configData.SPRID.ITEM_TITLE.substring(0,configData.SPRID.ITEM_TITLE.length-1)}`,trigger:""}]'>
        <el-radio-group v-model="form.SPRID">
          <el-radio v-for="(item1,index) in SPRData" :key="index" :label="item1.USERID">{{item1.USERNAME}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="configData.TITLE.ITEM_TITLE" prop="TITLE"
       :rules='[{required:true,message:`请输入${configData.TITLE.ITEM_TITLE.substring(0,configData.TITLE.ITEM_TITLE.length-1)}`,trigger:""}]'>
        <el-input v-model="form.TITLE" :placeholder="`请输入${configData.TITLE.ITEM_TITLE.substring(0,configData.TITLE.ITEM_TITLE.length-1)}`" clearable></el-input>
      </el-form-item>
      <el-form-item :label="configData.CONTENT.ITEM_TITLE" prop="CONTENT"
       :rules='[{required:true,message:`请输入${configData.CONTENT.ITEM_TITLE.substring(0,configData.CONTENT.ITEM_TITLE.length-1)}`,trigger:""}]'>
        <el-input v-model="form.CONTENT" :autosize="{ minRows: 5}" :placeholder="`请输入${configData.CONTENT.ITEM_TITLE.substring(0,configData.CONTENT.ITEM_TITLE.length-1)}`" clearable type="textarea"></el-input>
        <el-select v-model="comments" placeholder="-- 请选择批语 --" class="selectWidth" @input="commentChange">
          <el-option style="max-width: 300px !important;" v-for="(item,index) in commentList" :key="index" :label="item.CYPY" :value="item.CYPY">
            <div style="width:300px;white-space:pre-wrap;">{{item.CYPY}}</div>
          </el-option>
        </el-select>
      </el-form-item>
      <div class="el-form-item justify-content-center ds-fx align-items-center">
        <el-button type="primary" size="mini" @click="submit">发送</el-button>
        <el-button size="mini" @click="cancelClick">返回</el-button>
      </div>
    </el-form>
  </el-main>
</basic-container>
</template>

<script>
import {processDeal} from '@/api/home/home';
import {addShow} from '@/api/table/table';
import {mapGetters} from 'vuex';

export default {
components: {},
data() {
//这里存放数据
return {
  loading:false,
  configData:{},
  form:{},   // 审核表单
  formDisabled:false,   // 审核表单disabled
  SPRData:[],  // 审批人单选数组
  comments:"",  // 批语
  commentList:[],  // 批语list
  flowList:[],  // 流程下拉list
  flowDetail:[],  // 流程详情
};
},
//监听属性 类似于data概念
computed: {
  ...mapGetters(["userInfo"]),
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  //  提交
  async submit(){
    this.$refs.approvalForm.validate((valid) => {
      if (valid) {
        this.loading=true;
        // console.log(this.form);
        addShow({
          dwId:3052,
          data:{
            SRCTYPE:this.configData.SRCTYPE.ITEM_VALUE,
            SRCID:this.configData.SRCID.ITEM_VALUE,
            ...this.form,
          },
          runId:this.$route.query.runId,
        }).then(() => {
          this.loading=false;
          this.$message.success("发送成功!");
          // 关闭自己
          this.$store.commit("DEL_TAG", {value:this.$route.fullPath});
          this.$router.go(-1);
        }, error => {
          this.loading=false;
          
        });
      } else {
        return false;
      }
    });
  },
  //  批语改变就输入批语里
  commentChange(){
    this.form.CONTENT+=this.comments;
    this.comments="";
  },
  // 流程改变
  FLOWIDChange(){
    //  取审批流程信息
    processDeal({
      obj:JSON.stringify({
        id:17,
        flowid: this.form.FLOWID, // 审批流程ID（FLOWID）
      }),
    }).then(res=>{
      this.flowDetail=res.data.data;
    },err=>{})
    // 取审批人
    processDeal({
      obj:JSON.stringify({
        id:18,
        userid: this.userInfo.user_id, // 用户id
        srctype: this.configData.SRCTYPE.ITEM_VALUE, // 来源类型（SRCTYPE）
        srcid: this.configData.SRCID.ITEM_VALUE,  // 来源主键（SRCID）
        flowid: this.configData.FLOWID.ITEM_VALUE,  // 审批流程ID（FLOWID）
        cursort: 0, //当前环节顺序（固定传0）
        zgdwid: this.configData.ZGDWID.ITEM_VALUE, // 主管单位ID（ZGDWID）
        orgid: this.configData.JGID.ITEM_VALUE, // 机构ID(JGID)
      }),
    }).then(res=>{
      this.SPRData=res.data.data;
    },err=>{})
  },
  cancelClick(){
    // 关闭自己
    this.$store.commit("DEL_TAG", {value:this.$route.fullPath});
    this.$router.push({
      path:this.$route.query.path,
      query:{
        runId:this.$route.query.runId,
        name:this.$route.query.parentName,
      }
    })
  },
  async configFn(){
    this.loading=true;
    try {
      // 取审批配置
      let res=await processDeal({
        obj:JSON.stringify({userid:this.userInfo.user_id,id:15,srctype:this.$route.query.srctype,srcid:this.$route.query.srcid,runId:this.$route.query.runId}),
      })
      let array=res.data.data;
      let obj={col:[],form:[]};
      for (let i = 0; i < array.length; i++) {
        const config = array[i];
        if (config.ITEM_NAME=="OBJ_TITLE"||config.ITEM_NAME=="SRCTYPE"||config.ITEM_NAME=="SRCID") {
          obj[config.ITEM_NAME]=config;
        }else if(config.ITEM_NAME.indexOf("COL")==0){
          obj.col.push(config);
        }else{
          obj[config.ITEM_NAME]=config;
          this.$set(this.form,config.ITEM_NAME,config.ITEM_VALUE||"");
        }
      }
      this.configData=obj;
      if(this.form.FLOWID===-1){
        //  取审批流程下拉列表
        processDeal({
          obj:JSON.stringify({
            id:16,
            userid: this.userInfo.user_id, // 当前用户ID
            srctype: obj.SRCTYPE.ITEM_VALUE, // 来源类型（SRCTYPE）
            srcid: obj.SRCID.ITEM_VALUE, // 来源主键（SRCID）
            zgdwid: this.userInfo.company_id, // 主管单位ID（ZGDWID）
            orgid: this.userInfo.dept_id, // 机构ID(JGID)
          }),
        }).then(res=>{
          this.flowList=res.data.data;
        },err=>{})
        //  取审批流程信息
        processDeal({
          obj:JSON.stringify({
            id:17,
            flowid:  obj.FLOWID.ITEM_VALUE, // 审批流程ID（FLOWID）
          }),
        }).then(res=>{
          this.flowDetail=res.data.data;
        },err=>{})
      }
      // 取 批语信息
      processDeal({
        obj:JSON.stringify({
          userid:this.userInfo.user_id, // 用户id
          id:19,
          srctype: obj.SRCTYPE.ITEM_VALUE, //来源类型（SRCTYPE）
        }),
      }).then(res=>{
        this.commentList=res.data.data;
      },err=>{})
      processDeal({
        obj:JSON.stringify({
          id:18,
          userid:this.userInfo.user_id, // 用户id
          srctype: obj.SRCTYPE.ITEM_VALUE, // 来源类型（SRCTYPE）
          srcid: obj.SRCID.ITEM_VALUE,  // 来源主键（SRCID）
          flowid: obj.FLOWID.ITEM_VALUE,  // 审批流程ID（FLOWID）
          cursort: 0, //当前环节顺序（固定传0）
          zgdwid: obj.ZGDWID.ITEM_VALUE, // 主管单位ID（ZGDWID）
          orgid: obj.JGID.ITEM_VALUE, // 机构ID(JGID)
        }),
      }).then(res=>{
        this.SPRData=res.data.data;
      },err=>{})
      obj=null;
      this.loading=false;
    }catch(err){
      
    }
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
activated() {
  this.configFn();
}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.blue{
  color: #5cb6ff;
}
.title{
  margin: .5rem 0;
}
/deep/ .el-main{
  font-size: 14px;
  border-left: 1px solid #5cb6ff;
  border-top: 1px solid #5cb6ff;
  .left{
    text-align: right;
    background: rgb(228, 242, 250);
  }
  /deep/ .el-col{
    border-right: 1px solid #5cb6ff;
    border-bottom: 1px solid #5cb6ff;
    margin-bottom: 0;
    line-height: 30px;
    padding: 0 4px;
  }
}
.form{
  background: rgb(228, 242, 250);
  /deep/ .el-form-item{
    margin-bottom: 0;
    border-right: 1px solid #5cb6ff;
    border-bottom: 1px solid #5cb6ff;
    /deep/ .el-form-item__content{
      border-left: 1px solid #5cb6ff;
      background: #fff;
    }
    /deep/ .el-form-item__error{
      margin-top: -22px;
      margin-right: 6px;
      right: 0;
      left: auto;
    }
  }
}
.selectWidth{
  width: 100%;
}
.flowDetail{
  min-height: 28px;
}
</style>
